import * as _ from 'lodash'
import React, { useCallback, useState } from 'react';
import enums from '../enum';
import componentServices from '../componentServices';
import * as actions from '../actions';
import router from '../router';
import * as contractorActions from '../contractorActions';
import * as employeeActions from '../employeeActions';
import * as jobActions from '../jobActions';import util from '../util';
import globalRelay from '../globalRelay';
import valueFilters from '../valueFilters';
import validator from '../validator';

import ContactEdit from './contactEdit';
import AddressEdit from './addressEdit';

import contactModel from '../models/contactModel';
import addressModel from '../models/addressModel';

import { Button, Confirm, ContractorLockSection, PercentInput, PhoneInput, Popup, Radio, Section, sortableComponent, Spinner } from './sharedComponents';
import { DomainEntityType, getCollection, getDomainEntities, ModelCollection } from '../store';
import contractorNoteFactory, { IContractorNote } from 'Scripts/models/contractorNoteModel';
import { IModelSet } from 'Scripts/modelSet';

class LockModal extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = {
			note: ''
		};

		this.handleLockClick = this.handleLockClick.bind(this);
	}

	updateModel (path, clean, e) {
		e.preventDefault();

		const newVal = (clean) ? valueFilters.clean(e.target.value) : e.target.value;

		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState[path] = newVal;

			return newState;
		});
	}

	handleLockClick () {
		if (valueFilters.clean(this.state.note)) {
			this.props.lockContractor(this.state.note);
		}
	}

	render () {
		const { note } = this.state;
		const buttonClass = valueFilters.clean(note) ? 'action lock' : 'action lock disabled';

		return (<div className="window">
			<header>
				<Button className="cancel" label="Cancel" onClick={ actions.popModal }/>
				<span>Lock Contractor</span>
				<Button className={ buttonClass} label="LOCK" onClick={ this.handleLockClick } />
			</header>
			<div className="views">
				<div className="content in scrollable">
					<section>
						<div className="inner">

							<h2>Locking this Contractor will disable new Estimates and Contracts. Enter a note below to explain the reason for the lock.</h2>

							<table className="centered" cellPadding="0" cellSpacing="0">
								<tbody>
									<tr className="">
										<td />
										<td>
											<textarea placeholder="Add a Note" value={ note } onChange={this.updateModel.bind(this, 'note', false) } onBlur={this.updateModel.bind(this, 'note', true) } />
										</td>
										<td />
									</tr>
								</tbody>
							</table>
						</div>
					</section>
				</div>
			</div>
		</div>);
	}
}

class BasicInfo extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.updateModel = this.updateModel.bind(this);
		this.updatePhone = this.updatePhone.bind(this);
		this.lockContractor = this.lockContractor.bind(this);
		this.handleLockClick = this.handleLockClick.bind(this);
		this.handleUnlockClick = this.handleUnlockClick.bind(this);
	}
	validate (property) {
		return this.props.contractor.isValid(property);
	}
	updateModel (path, autoSave, e) {
		let newVal;
		if (e.target.type === 'checkbox') {
			newVal = e.target.checked;
		}
		else {
			newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;
		}

		this.props.updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}
	updatePhone (phoneType, autoSave, e) {
		const viewValue = e.target.value;

		this.props.updateModel(model => {
			model.setPhoneNumber(phoneType, viewValue);
		}, { autoSave: autoSave });
	}
	lockContractor (note) {
		this.props.updateModel(model => {
			model.statusLog.add({ status: 'locked', description: note });
			actions.popModal();
		}, { autoSave: true });
	}
	handleLockClick () {
		actions.pushModal({
			component: <LockModal lockContractor={ this.lockContractor} />
		});
	}
	handleUnlockClick () {
		this.props.updateModel(model => {
			model.statusLog.add({ status: 'active' });
		}, { autoSave: true });
	}
	render () {
		const { contractor } = this.props;
		const currentModule = componentServices.routeParams.modulekey;

		const subtradeTypes = _.sortBy(getDomainEntities({ store: componentServices.store, type: DomainEntityType.subTradeTypes }), ['name']);
		const globalConfig = globalRelay.config!;
		const paymentTerms = globalConfig.jobCostSettings.paymentTerms;
		const defaultSubtradeTypeRow = (!enums.contractorTypes.isSet(enums.contractorTypes.Subtrade_Contractor, contractor.type)) ? null
			: (<tr>
				<td />
				<td>
					<strong>Default Subtrade Type</strong>
				</td>
				<td className={!this.validate('defaultSubTradeTypeKey') ? 'required' : ''}>
					<select value={contractor.viewValue('defaultSubTradeTypeKey')} onChange={this.updateModel.bind(this, 'defaultSubTradeTypeKey', true)}>
						<option key="empty" value="">Select</option>
						{ _.map(subtradeTypes, t => <option key={ t.key } value={ t.key }>{ t.name }</option>) }
					</select>
				</td>
				<td />
			</tr>);

		const termsRow = enums.contractorTypes.isSet(enums.contractorTypes.Subtrade_Contractor, contractor.type) || enums.contractorTypes.isSet(enums.contractorTypes.Delivery_Company, contractor.type) ? null
			: (<tr>
				<td />
				<td>
					<strong>Terms</strong>
				</td>
				<td className={!this.validate('paymentTermsKey') ? 'required' : ''}>
					{ !componentServices.securityContext.currentUserHasFeature(currentModule, 'contractor-terms') ? (paymentTerms[contractor.paymentTermsKey || 'default'].name)
						: (<select value={contractor.viewValue('paymentTermsKey')} onChange={this.updateModel.bind(this, 'paymentTermsKey', true)}>
							{ _.map(paymentTerms, (v, k) => <option key={ k } value={ k }>{ v.name }</option>) }
						</select>)
					}
				</td>
				<td />
			</tr>);

		const discountRow = (!enums.contractorTypes.isSet(enums.contractorTypes.Developer, contractor.type) && !enums.contractorTypes.isSet(enums.contractorTypes.Multifamily_Developer, contractor.type) && !enums.contractorTypes.isSet(enums.contractorTypes.Retail_Builder, contractor.type)) ? null
			: (<tr>
				<td />
				<td>
					<strong>Discount %</strong>
				</td>
				<td className={!this.validate('discountPercent') ? 'required' : ''}>
					<PercentInput onChange={ this.updateModel.bind(this, 'discountPercent', false) } onBlur={ this.updateModel.bind(this, 'discountPercent', true) } value={ contractor.viewValue('discountPercent') } placeholder="Discount %" />
				</td>
				<td />
			</tr>);

		const taxExemptRow = (enums.contractorTypes.isSet(enums.contractorTypes.Delivery_Company, contractor.type)? null: <tr>
			<td />
			<td>
				<strong>Tax Exempt?</strong>
			</td>
			<td>
				<input type="checkbox" placeholder="Main Office Fax" checked={ contractor.isTaxExempt } onChange={this.updateModel.bind(this, 'isTaxExempt', true)}/>
			</td>
			<td />
		</tr>);

		return (
			<section>
				<header>
					<span>COMPANY</span>
				</header>
				<div>
					<table className="half" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td />
								<td>
									<strong>Name</strong>
								</td>
								<td className={!this.validate('name') ? 'required' : ''}>
									<input type="text" placeholder="Name" autoCapitalize="" autoCorrect="off" value={contractor.viewValue('name')} onChange={this.updateModel.bind(this, 'name', false)} onBlur={this.updateModel.bind(this, 'name', true)} />
								</td>
								<td />
							</tr>
							<tr>
								<td />
								<td>
									<strong>Accounting ID</strong>
								</td>
								<td className={!this.validate('accountingId') ? 'required' : ''}>
									<input type="text" placeholder="Accounting ID" autoCapitalize="" autoCorrect="off" value={contractor.viewValue('accountingId')} onChange={this.updateModel.bind(this, 'accountingId', false)} onBlur={this.updateModel.bind(this, 'accountingId', true)} />
								</td>
								<td />
							</tr>
							{ defaultSubtradeTypeRow || termsRow }
							{ discountRow }
						</tbody>
					</table>
					<table className="half" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td />
								<td>
									<strong>Main Office Phone</strong>
								</td>
								<td className={(!!contractor.workPhoneNumber && !validator.isPhone(contractor.workPhoneNumber)) ? 'required' : ''}>
									<PhoneInput placeholder="Main Office Phone" autoCapitalize="" autoCorrect="off" value={contractor.viewValue('workPhoneNumber')} onChange={this.updatePhone.bind(this, enums.phoneNumberTypes.Work, false)} onBlur={this.updatePhone.bind(this, enums.phoneNumberTypes.Work, true)} />
								</td>
								<td />
							</tr>
							<tr>
								<td />
								<td>
									<strong>Main Office Fax</strong>
								</td>
								<td className={(!!contractor.faxPhoneNumber && !validator.isPhone(contractor.faxPhoneNumber)) ? 'required' : ''}>
									<PhoneInput placeholder="Main Office Fax" autoCapitalize="" autoCorrect="off" value={contractor.viewValue('faxPhoneNumber')} onChange={this.updatePhone.bind(this, enums.phoneNumberTypes.Fax, false)} onBlur={this.updatePhone.bind(this, enums.phoneNumberTypes.Fax, true)}/>
								</td>
								<td />
							</tr>
							{ taxExemptRow }
							{ componentServices.securityContext.currentUserHasFeature(currentModule, 'contractor-lock') ? <tr>
								<td />
								<td />
								<td>
									<Button className="action iconLabel unlock" label={ contractor.currentStatus === 'locked' ? 'UNLOCK THIS CONTRACTOR' : 'LOCK THIS CONTRACTOR'} onClick={ contractor.currentStatus === 'locked' ? this.handleUnlockClick : this.handleLockClick} />
								</td>
								<td />
							</tr> : null
							}
						</tbody>
					</table>
				</div>
			</section>
		);
	}
}

class ContractorTypeSection extends React.Component<any,any> {
	render () {
		const { contractor, handleTypeChange } = this.props;
		const allowedTypes = componentServices.routeParams.modulekey === 'retail-sales' ? [enums.contractorTypes.Retail_Builder, enums.contractorTypes.Renovation_Contractor, enums.contractorTypes.Subtrade_Contractor, enums.contractorTypes.Delivery_Company] : [enums.contractorTypes.Delivery_Company];
		const checklistItems = _.map(allowedTypes, type => {
			const scopeItemButtons = [
				{ classNames: ['icon yes'], isSelected: enums.contractorTypes.isSet(type, contractor.type), value: type, key: `${type}-on` },
				{ classNames: ['icon no'], isSelected: !enums.contractorTypes.isSet(type, contractor.type), value: type, key: `${type}-off` }
			];
			const rowClasses:string[] = [];

			if (enums.contractorTypes.isSet(type, contractor.type)) {
				rowClasses.push('yes');
			}
			else {
				rowClasses.push('no');
			}

			return (
				<tr className={ rowClasses.join(' ') } key={ type }>
					<td />
					<td>
						<Radio buttons={ scopeItemButtons } onChange={ handleTypeChange } />
					</td>
					<td>{ enums.contractorTypes.getDisplayName(type) }</td>
					<td />
				</tr>
			);
		});

		return (<section>
			<header>
				<span>CATEGORIES</span>
			</header>
			<div>
				<table className="checklist" cellPadding="0" cellSpacing="0">
					<tbody>
						{ checklistItems }
					</tbody>
				</table>
			</div>
		</section>);
	}
}

class ContractorPersonnel extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);
	}

	// UNSAFE_componentWillReceiveProps (nextProps) {
	// 	this.setState(this.getStateFromProps(nextProps));
	// }

	getStateFromProps(props) {
		const { contractor } = props;
		const nextState = {} as any;

		if (!nextState.contractor || nextState.contractor.key !== contractor.key) {
			nextState.contractorUserKey = contractor.createdById || contractor.lastModifiedById;
			nextState.contractor = contractor;
			nextState.mostRecentJobCost = undefined;

			if (contractor.modifiedOrCreatedById && !employeeActions.getEmployeeByUserKey(contractor.modifiedOrCreatedById)) {
				employeeActions.fetchEmployee({ userKey: contractor.modifiedOrCreatedById });
			}

			jobActions.searchJobs({ builderKey: contractor.key })
				.then(result => {
					const mostRecentJobCost = _.reduce(result, (mostRecent, job) => {
						let reduceResult = mostRecent;
						const jobCosts = _.filter(job.jobCosts, jc => !!jc.jobKey); // this is only set for search results
						_.forEach(jobCosts, jc => {
							if (!mostRecent || mostRecent.dateCreated < jc.dateCreated) {
								reduceResult = jc;
							}
						});
						return reduceResult;
					}, undefined);

					if (mostRecentJobCost && !employeeActions.getEmployeeByUserKey(mostRecentJobCost.createdById)) {
						employeeActions.fetchEmployee({ userKey: mostRecentJobCost.createdById });
					}

					this.setState({ mostRecentJobCost: mostRecentJobCost });
				});
		}

		return nextState;
	}

	render () {
		const { contractor, mostRecentJobCost } = this.state;
		const statusEmployee = (mostRecentJobCost && employeeActions.getEmployeeByUserKey(mostRecentJobCost.createdById)) || (contractor.modifiedOrCreatedById && employeeActions.getEmployeeByUserKey(contractor.modifiedOrCreatedById));
		const actionLabel = mostRecentJobCost ? (mostRecentJobCost.isContract ? 'Contract' : 'Estimate') : 'Modified';
		const statusMessage = `${actionLabel} by ${(statusEmployee && statusEmployee.fullName) || 'unknown' } on ${ util.dateHelper.formatDate((mostRecentJobCost && mostRecentJobCost.dateCreated) || contractor.dateModifiedOrCreated, { format: 'MM/dd/yyyy' }) }`;
		const personnelTitle = `${globalRelay.config!.shortCompanyName} Personnel`;

		return (<section>
			<header><span>{ personnelTitle.toUpperCase() }</span></header>
			<div>
				<table className="" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td />
							<td>{ statusMessage }</td>
							<td />
						</tr>
					</tbody>
				</table>
			</div>
		</section>);
	}
}

const ContractorNoteContextMenu = ({ deleteAction }) => {
	const onDeleteClicked = () => {
		deleteAction();
	};

	return	(<div className="content scrollable">
		<ul className="menu">
			<li><a className="button icon iconLabel removeItem delete" onClick={ onDeleteClicked }><span>Delete</span></a></li>
		</ul>
	</div>);
};

class AddContractorNoteTable extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleButtonClick = this.handleButtonClick.bind(this);
	}

	updateModel (autoSave, e) {
		e.preventDefault();

		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(note => {
			note.setAt('content', newVal);
		}, { autoSave: autoSave });
	}

	handleButtonClick (e) {
		e.preventDefault();

		const newVal = valueFilters.clean(this.props.note.content);

		if (_.isEmpty(newVal)) {
			return;
		}

		this.props.addNoteHandler();
	}

	render () {
		const { note } = this.props;

		return (
			<table className="compact notes" cellPadding="0" cellSpacing="0">
				<tbody>
					<tr>
						<td />
						<td className="note"><textarea placeholder="Add a Note" onChange={this.updateModel.bind(this, false)} onBlur={this.updateModel.bind(this, true)} value={note.viewValue('content')} /></td>
						<td className="action"><button className="icon iconOnly addItem" onClick={this.handleButtonClick} ><span /></button></td>
						<td />
					</tr>
				</tbody>
			</table>
		);
	}
}

const ContractorNoteTable = sortableComponent(class NoteTableInner extends React.Component<any,any> {
	handleClick (k, e) {
		e.preventDefault();
		this.props.updateSort(k);
	}

	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}

	render () {
		const { list, deleteNote } = this.props;
		const rows:JSX.Element[] = [];

		list.forEach((note) => {
			rows.push(<NoteTableRow note={note} key={note.key} deleteNote={ deleteNote } />);
		});

		return (
			<table className="sortable" cellPadding="0" cellSpacing="0">
				<thead>
					<tr>
						<td />
						<td className={this.getClassName('dateCreated')} onClick={this.handleClick.bind(this, 'dateCreated')}>Date</td>
						<td className={this.getClassName('content')} onClick={this.handleClick.bind(this, 'content')}>Note</td>
						<td className={this.getClassName('addedBy')} onClick={this.handleClick.bind(this, 'addedBy')}>Added By</td>
						<td />
						<td />
					</tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
			</table>
		);
	}
});

function NoteTableRow({ note, deleteNote }: { note: IContractorNote & { addedBy: string }, deleteNote: (key:string) => void}) {

	const doDelete = useCallback(() => {
		deleteNote(note.key);
		actions.popModal();
	}, [note, deleteNote]);

	const handleContextClick = useCallback((e) => {
		const popup = <Popup target={e.target}><ContractorNoteContextMenu deleteAction={ doDelete } /></Popup>;

		actions.pushModal({ component: popup });
	}, [doDelete])

	return (
		<tr className="added">
			<td />
			<td className="date"><strong>{util.dateHelper.formatDate(note.dateCreated, { userFriendly: true })}</strong></td>
			<td className="note">{note.content}</td>
			<td className="addedBy">{note.addedBy}</td>
			<td className="action"><button className="icon iconOnly contextMenu" onClick={handleContextClick}><span /></button></td>
			<td />
		</tr>
	);
}

function ContractorNotes({ title, notes, updateNotes }: {  title: string, notes: IModelSet<IContractorNote>, updateNotes: (updater: (notes: IModelSet<IContractorNote>) => void, options: { autoSave: boolean}) => void }) {
	const createPendingNote = () => {
		return contractorNoteFactory();
	}
	const [pendingNote, setPendingNote] = useState<IContractorNote>(createPendingNote);

	const addNoteHandler = useCallback(() => {
		updateNotes((notes: IModelSet<IContractorNote>) => {
			notes.set(pendingNote.key, pendingNote);
			setPendingNote(createPendingNote());
		}, { autoSave: true });
	}, [updateNotes, pendingNote]);

	const deleteNote = useCallback((noteKey: string) => {
		updateNotes(notes => {
			notes.delete(noteKey);
		}, { autoSave: true });
	}, [updateNotes]);

	const updateNote = useCallback((key, updater, options) => {
		updateNotes(notes => {
			let note = notes.get(key);

			if ((!note) && (key === pendingNote.key)) {
				note = pendingNote;
				options.autoSave = false;
			}

			if (note) {
				updater(note);
			}
		}, options);
	}, [updateNotes]);

	const { store } = componentServices;
	const employees = getCollection({ store, collection: ModelCollection.employees });

	const list = _.map(notes, note => {
		const employee = employees.find(e => {
			return e.user.key === note.createdById;
		});

		return _.assign({ addedBy: (employee ? employee.fullName : 'Unknown') }, note.toDocument());
	});

	return (
		<section>
			<header>
				<span>{title}</span>
			</header>
			<div className = "inner">
				<div>
					<AddContractorNoteTable key={ pendingNote.key } note={pendingNote} addNoteHandler={addNoteHandler} updateModel={ (u, o) => updateNote(pendingNote.key, u, o)} />
					<ContractorNoteTable list={ list } initialSortKey="dateCreated" deleteNote={ deleteNote } updateModel={updateNote} />
				</div>
			</div>
		</section>
	);
}


export default class ContractorEditOverview extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.updateModel = this.updateModel.bind(this);
		this.validateContact = this.validateContact.bind(this);
		this.validateAddress = this.validateAddress.bind(this);
		this.handleTypeChange = this.handleTypeChange.bind(this);
		this.handleDeleteClick = this.handleDeleteClick.bind(this);
	}



	validateContact (contact, property) {
		return contact.isEmpty() || contact.isValid(property);
	}

	validateAddress (address, property) {
		return address.isEmpty() || address.isValid(property);
	}

	handleTypeChange (newButton) {
		const { contractor, updateModel } = this.props;
		let newType = contractor.type;

		if (enums.contractorTypes.isSet(newButton.value, contractor.type)) {
			newType = enums.contractorTypes.unset(newButton.value, contractor.type);
		}
		else {
			newType = enums.contractorTypes.set(newButton.value, contractor.type);
		}

		updateModel(model => {
			model.type = newType;
		}, { autoSave: true });
	}

	handleDeleteClick () {
		const { contractor } = this.props;

		if (contractor && this.canDelete()) {
			const popup = <Confirm title={ 'Permanently Delete Contractor?' } message={ 'Are you sure you want to permanently delete this Contractor? This cannot be undone.' } confirmLabel="Permanently Delete" cancelLabel="Cancel" cancelHandler={ actions.popModal } confirmHandler={ this.doDelete.bind(this) } />;

			actions.popModal();
			actions.pushModal({ component: popup });
		}
	}

	doDelete (e) {
		const { contractor } = this.props;
		const modalKey = 'contractor-delete-spinner';

		e.preventDefault();

		actions.popModal();
		actions.pushModal({ key: modalKey, component: (<Spinner />) });

		componentServices.router.replaceHistory(componentServices.router.splicePathSegments(2, 10));

		contractorActions.deleteContractor({ contractor })
			.finally(() => {
				actions.deleteModal({ key: modalKey });
			});
	}

	canDelete () {
		const moduleKey = router.currentState.params.modulekey;
		const securityContext = componentServices.securityContext;

		return securityContext.currentUserHasFeature(moduleKey, 'contractor-delete');
	}

	updateModel (path, factory, updater, options) {
		this.props.updateModel(model => {
			let updateTarget = model.getAt(path);

			if (!updateTarget) { // auto-create the child model if it doesn't exist
				updateTarget = factory();
				model.setAt(path, updateTarget);
			}
			updater(updateTarget);
		}, options);
	}

	updateSet (path, updater, options) {
		this.props.updateModel(model => {
			const updateTarget = model.getAt(path);

			updater(updateTarget);
		}, options);
	}

	render () {
		const { contractor } = this.props;
		const currentModule = componentServices.routeParams.modulekey;

		return (
			<div className="contactInfo">
				<ContractorLockSection contractor={contractor} />
				<section>
					<ContractorPersonnel key={contractor.key} contractor={contractor} />
					<BasicInfo contractor={contractor} updateModel={this.props.updateModel} />
					{ currentModule !== 'builder-sales' ? <ContactEdit contact={ contractor.primaryContact || contactModel({ priority: 0 }) } title="PRIMARY CONTACT" validate={ this.validateContact } updateModel={this.updateModel.bind(this, 'primaryContact', contactModel)} /> : null }
					<Section title="ADDRESS"><AddressEdit address={ contractor.officeAddress || addressModel() } validate={ this.validateAddress } updateModel={this.updateModel.bind(this, 'officeAddress', addressModel)} /></Section>
					<ContractorNotes key={ contractor.key } notes={ contractor.notes} title="INTERNAL NOTES" updateNotes={this.updateSet.bind(this, 'notes')} />
					{ currentModule !== 'builder-sales' ? <ContractorTypeSection contractor={ contractor } handleTypeChange={ this.handleTypeChange } /> : null }
				</section>
				{ this.canDelete() ? <footer><div className="actions"><button className="labelOnly deleteItem" onClick={ this.handleDeleteClick }>Permanently Delete this Contractor</button></div></footer> : null }
			</div>
		);
	}
}